"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _wechatOpenPlatformApi = require("@/api/wechatOpenPlatformApi");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  data: function data() {
    return {
      platforms: [],
      platformId: null,
      activeTab: 'draft',
      drafts: [],
      templates: [],
      draftLoading: false,
      templateLoading: false,
      operationKey: ''
    };
  },
  created: function () {
    var _created = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var ready, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _context.n = 1;
            return (0, _wechatOpenPlatformApi.getPlatformList)();
          case 1:
            _t = _context.v;
            if (_t) {
              _context.n = 2;
              break;
            }
            _t = [];
          case 2:
            this.platforms = _t;
            ready = this.platforms.find(function (item) {
              return item.enabled === 1;
            });
            if (ready) this.platformId = ready.id;
            _context.n = 3;
            return this.loadAll();
          case 3:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function created() {
      return _created.apply(this, arguments);
    }
    return created;
  }(),
  methods: {
    loadAll: function () {
      var _loadAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (this.platformId) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              _context2.n = 2;
              return Promise.all([this.loadDrafts(), this.loadTemplates()]);
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function loadAll() {
        return _loadAll.apply(this, arguments);
      }
      return loadAll;
    }(),
    loadDrafts: function () {
      var _loadDrafts = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _t2;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.draftLoading = true;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _wechatOpenPlatformApi.getTemplateDraftList)(this.platformId);
            case 2:
              _t2 = _context3.v;
              if (_t2) {
                _context3.n = 3;
                break;
              }
              _t2 = [];
            case 3:
              this.drafts = _t2;
            case 4:
              _context3.p = 4;
              this.draftLoading = false;
              return _context3.f(4);
            case 5:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 4, 5]]);
      }));
      function loadDrafts() {
        return _loadDrafts.apply(this, arguments);
      }
      return loadDrafts;
    }(),
    loadTemplates: function () {
      var _loadTemplates = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var _t3;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (this.platformId) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.templateLoading = true;
              _context4.p = 2;
              _context4.n = 3;
              return (0, _wechatOpenPlatformApi.getTemplateList)(this.platformId);
            case 3:
              _t3 = _context4.v;
              if (_t3) {
                _context4.n = 4;
                break;
              }
              _t3 = [];
            case 4:
              this.templates = _t3;
            case 5:
              _context4.p = 5;
              this.templateLoading = false;
              return _context4.f(5);
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this, [[2,, 5, 6]]);
      }));
      function loadTemplates() {
        return _loadTemplates.apply(this, arguments);
      }
      return loadTemplates;
    }(),
    handleAdd: function () {
      var _handleAdd = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(row) {
        var _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return this.$confirm("\u786E\u8BA4\u5C06\u8349\u7A3F ".concat(row.draftId, " \u6DFB\u52A0\u5230\u6A21\u677F\u5E93\uFF1F"), '添加模板', {
                type: 'warning'
              });
            case 1:
              _context5.n = 3;
              break;
            case 2:
              _context5.p = 2;
              _t4 = _context5.v;
              return _context5.a(2);
            case 3:
              this.operationKey = "add-".concat(row.draftId);
              _context5.p = 4;
              _context5.n = 5;
              return (0, _wechatOpenPlatformApi.addTemplate)({
                platformId: this.platformId,
                draftId: row.draftId
              });
            case 5:
              this.$message.success('模板添加成功');
              _context5.n = 6;
              return this.loadAll();
            case 6:
              this.activeTab = 'template';
            case 7:
              _context5.p = 7;
              this.operationKey = '';
              return _context5.f(7);
            case 8:
              return _context5.a(2);
          }
        }, _callee5, this, [[4,, 7, 8], [0, 2]]);
      }));
      function handleAdd(_x) {
        return _handleAdd.apply(this, arguments);
      }
      return handleAdd;
    }(),
    handleDelete: function () {
      var _handleDelete = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(row) {
        var _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.$confirm("\u786E\u8BA4\u5220\u9664\u6A21\u677F ".concat(row.templateId, "\uFF1F\u5220\u9664\u540E\u4E0D\u53EF\u6062\u590D\u3002"), '删除模板', {
                type: 'warning'
              });
            case 1:
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t5 = _context6.v;
              return _context6.a(2);
            case 3:
              this.operationKey = "delete-".concat(row.templateId);
              _context6.p = 4;
              _context6.n = 5;
              return (0, _wechatOpenPlatformApi.deleteTemplate)(this.platformId, row.templateId);
            case 5:
              this.$message.success('模板已删除');
              _context6.n = 6;
              return this.loadTemplates();
            case 6:
              _context6.p = 6;
              this.operationKey = '';
              return _context6.f(6);
            case 7:
              return _context6.a(2);
          }
        }, _callee6, this, [[4,, 6, 7], [0, 2]]);
      }));
      function handleDelete(_x2) {
        return _handleDelete.apply(this, arguments);
      }
      return handleDelete;
    }(),
    formatTime: function formatTime(value) {
      if (!value) return '-';
      var date = new Date(Number(value) * 1000);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(date.getFullYear(), "-").concat(pad(date.getMonth() + 1), "-").concat(pad(date.getDate()), " ").concat(pad(date.getHours()), ":").concat(pad(date.getMinutes()), ":").concat(pad(date.getSeconds()));
    }
  }
};